import { useCallback } from "react"
import Card from "modules/Core/sub-modules/ui-kit/components/Card";
import Container from "modules/Core/sub-modules/ui-kit/components/Container";
import Text from "modules/Core/sub-modules/ui-kit/components/Text";
import Button from "modules/Core/sub-modules/ui-kit/components/Button";
import { useIsOpen } from "modules/Core/hooks/useIsOpen";
import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import cells from "modules/cycles/state";
import { ACTIVITY_KIND } from "modules/cycles/consts";
import ActivityForm from "../ActivityForm";
import styles from "./styles.module.scss";

const EmptyActivityCard = ({
    activity,
    cycleId,
    boothId,
    refetch,
    assign,
    remove,
}) => {
    const { open, close, isOpen } = useIsOpen();
    const onSuccess = useCallback((result) => {
        refetch?.()
        return result
    }, [refetch]);

    const onSelectActivity = useCallback((selected, callback) => {
        assign({
            cycleId,
            placeholderId: activity?.id,
            activityId: selected?.id,
            callback,
        })
    }, [activity?.id, assign, cycleId]);

    return (
        <Card className={styles.emptyCard}>
            <Container flex spaceBetween alignCenter p1 maxWidth>
                <Text>Empty</Text>
                <Container className={styles.actions} flex alignCenter>
                    {remove && (
                        <Button onClick={remove}>
                            Remove
                        </Button>
                    )}
                    <Button onClick={open}>
                        Add
                    </Button>
                </Container>
            </Container>
            <ActivityForm
                activityId={activity?.id}
                cycleId={cycleId}
                boothId={boothId}
                kind={ACTIVITY_KIND.STANDARD}
                onSelectActivity={onSelectActivity}
                onSuccess={onSuccess}
                isOpen={isOpen}
                close={close}
                title="Add to cycle"
            />
        </Card>
    )
};

export default strappedConnected(
    EmptyActivityCard,
    {},
    {
        assign: cells.assignActivityToCycle.action,
    },
    ({ activity, cycleId, boothId, refetch }) => ({
        activity,
        cycleId,
        boothId,
        refetch,
    })
)
